import Vue from 'vue'
import store from '@/store'
import ListenReadEvaluateModel from '@/components/test/EvaluateModel.vue'
import ChoiceEvaluateModel from '@/components/test/ChoiceEvaluateModel.vue'
import GapFillingEvaluateModel from '@/components/test/GapFillingEvaluateModel.vue'
import WordEvaluateModel from '@/components/test/WordEvaluateModel.vue'

const ListenReadEvaluateModelConstructor = Vue.extend(ListenReadEvaluateModel)
const ChoiceEvaluateModelConstructor = Vue.extend(ChoiceEvaluateModel)
const GapFillingEvaluateModelConstructor = Vue.extend(GapFillingEvaluateModel)
const WordEvaluateModelConstructor = Vue.extend(WordEvaluateModel)

export const EvaluateModalTypeEnum = {
  record: 'record',
  choice: 'choice',
  gapFilling: 'gapFilling',
  word: 'word'
}

const compMap = {
  // 听说评测结果
  record: ListenReadEvaluateModelConstructor,
  // 选择题答案
  choice: ChoiceEvaluateModelConstructor,
  // 填空题答案
  gapFilling: GapFillingEvaluateModelConstructor,
  // 单词评测结果
  word: WordEvaluateModelConstructor
}

export default function (options) {
  return new Promise((resolve, reject) => {
    const ModalConstructor = compMap[options.evaluateType]
    if (!ModalConstructor) {
      throw new Error(`未处理的评测类型：${options.evaluateType}`)
    }

    const instance = new ModalConstructor({
      store,
      data: options
    })

    instance.$mount()
    document.body.appendChild(instance.$el)

    instance.changeVisible(true)
  })
}
